import React from 'react';
import { CustomModal, FormBuilder, Loader } from 'commons-ui';
import { styles } from 'pages/dashboard/finance/ctd/priorityconfigurator/submodules/updatePriorityList/updatePriorityList.style';
import PriorityTags from 'pages/dashboard/finance/ctd/priorityconfigurator/submodules/updatePriorityList/PriorityListTags';
import useEdit from './useEdit';
import { validationSchema, constructFormConfig, constructFormData } from '../../utils/formConfig';
import AddNewPaymentGateway from '../addNewPaymentGateway';

const UpdateConfig: React.FC<{}> = () => {
	const {
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader,
		formDefaultData,
		formColumns,
		handleInputChange,
		uniqueUpiHandlerArray,
		uniqueBankNamesArray,
		uniqueUpiHandlerArrayInputText,
		uniqueBankNamesArrayInputText
	} = useEdit();
	return (
		<>
			<div style={styles.mainContainer}>
				{showLoader && <Loader />}
				<h1 style={styles.mainHeading}> Payment Mediator Config</h1>
				<div style={styles.priorityList}>
					<h2>Unique UPI Handler Array</h2>
					<PriorityTags priorities={uniqueUpiHandlerArray} />
					<div style={styles.updateSection}>
						<textarea
							value={uniqueUpiHandlerArrayInputText}
							style={styles.textarea}
							rows='5'
							name='uniqueUpiHandleArray'
							onChange={handleInputChange}
							placeholder='Enter user ctd payout segment'
						/>
					</div>
				</div>
				<div style={styles.priorityList}>
					<h2>Unique IMPS Bank Handler Array</h2>
					<PriorityTags priorities={uniqueBankNamesArray} />
					<div style={styles.updateSection}>
						<textarea
							value={uniqueBankNamesArrayInputText}
							style={styles.textarea}
							rows='5'
							name='uniqueBankNamesArray'
							onChange={handleInputChange}
							placeholder='Enter user ctd payout segment'
						/>
					</div>
				</div>
				<br />
				<h1 style={styles.mainHeading}> Static Traffic Distribution</h1>
				<AddNewPaymentGateway />
				{(Object.keys(formDefaultData?.upi).length > 0 || Object.keys(formDefaultData?.imps).length > 0) && (
					<FormBuilder
						data={formDefaultData}
						mode='create'
						showLoader={showLoader}
						handleFormSubmit={handleFormSubmit}
						handleFormCancel={handleFormCancel}
						validationSchema={validationSchema}
						setShowLoader={setShowLoader}
						fieldConfig={constructFormConfig(formColumns)}
						layoutConfig={constructFormData(formColumns)}
					/>
				)}
				<CustomModal />
			</div>
		</>
	);
};

export default UpdateConfig;
